export const portalConfig = {
    id: 'clinics',
    title: 'Gestão da clínica',
    allowedRoles: ['ACCOUNT_ADMIN', 'CLINIC_ADMIN'],
    companyUrl: 'https://www.cardio-id.com',
    drawerWidth: 210,
    headerHeight: 80,
    routes: [
        { id: 'home', path: '/', title: 'Início', sidebar: true },
        { id: 'administratives', path: '/administratives', title: 'Administrativos', sidebar: true, allowedRoles: ['ACCOUNT_ADMIN'] },
        { id: 'professionals', path: '/professionals', title: 'Profissionais', sidebar: true, allowedRoles: ['CLINIC_ADMIN'] },
        { id: 'patients', path: '/patients', title: 'Pacientes', sidebar: true, allowedRoles: ['CLINIC_ADMIN'] },
        { id: 'agenda', path: '/agenda', title: 'Agenda', sidebar: true, allowedRoles: ['CLINIC_ADMIN'] },
        { id: 'organization', path: '/organization', title: 'Organização', sidebar: true, allowedRoles: ['ACCOUNT_ADMIN', 'CLINIC_ADMIN'] },
        { id: 'settings', path: '/settings', title: 'Definições', accountMenu: true },
        { id: 'profile', path: '/profile', title: 'Perfil', accountMenu: true }
    ]
};
export const getPortalRoute = (pathname) =>
    portalConfig.routes.find((route) => route.path === (pathname.replace(/\/$/, '') || '/'));
